import { cn } from "../../lib"
import Glyph from "./Glyph"

type Props = {
  variant?: "full" | "glyph" | "wordmark"
  size?: string | number
  className?: string
}

export default function Logo({ variant = "full", size, className }: Props) {
  const style = size
    ? { fontSize: typeof size === "number" ? `${size}px` : size }
    : undefined

  return (
    <span
      className={cn("inline-flex items-center gap-[0.08em]", className)}
      style={style}
    >
      {variant !== "wordmark" && <Glyph variant="tricolor" size="1.2em" />}
      {variant !== "glyph" && (
        <span className="font-title text-[1em] leading-none tracking-tight">
          <span>Prompt</span>
          <span className="text-spark-orange">Juggler</span>
        </span>
      )}
    </span>
  )
}
